<template>
  <v-toolbar 
    app
    clipped-left
    clipped-right
    color="primary"
    dark
  >
    <v-toolbar-title>
      <router-link
        to="/"
        class="white--text toolbar-title"
      >
        脱出メイト
      </router-link>
    </v-toolbar-title>

    <v-spacer />

    <v-toolbar-items>
      <v-btn
        v-if="is_authenticated"
        flat
        @click="mypage()"
      >
        マイページ
      </v-btn>
      <v-btn
        v-else
        flat
        @click="signin"
      >
        ログイン
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import * as auth from "@/plugins/authenticate"
import firebase from "@/plugins/firebase"

export default {
  data() {
    return {
      is_authenticated: false,
    }
  },
  mounted() {
    this.is_authenticated = firebase.auth().currentUser ? true : false;
    this.onAuthStateChanged()
  },
  methods: {
    onAuthStateChanged() {
      firebase.auth().onAuthStateChanged((user) => {
        this.is_authenticated = user ? true: false
      })
    },
    signin() {
      this.$router.push({ path: '/sign'})
    },
    mypage() {
      this.$router.push({ path: `/users/${firebase.auth().currentUser.uid}`})
    },
  }
}
</script>

<style>
.toolbar-title {
  color: inherit;
  text-decoration: inherit;
}
</style>
